/* eslint-disable max-statements */
import { Card, Image } from 'react-bootstrap';
import Helmet from 'react-helmet';
import { useEffect } from 'react';

import { useReport } from '../ReportContext';

import Emotions from './Emotions';
import EmpathyCompassion from './EmpathyCompassion';
import RelationshipStrategies from './RelationshipStrategies';
import SelfOther from './SelfOther';
import { useAuth } from '../../services/eqqo.auth.service';

import EqqoInfinity from '../../../assets/images/eqqo-infinity-large.webp';

import './PrintReport.scss';

const PrintReport = () => {
	const { user: { firstName, lastName } } = useAuth();
	const { reportContent: { acf: { introduction } } } = useReport();

	useEffect(() => {
		// Give some time for the page to render before triggering print
		const timer = setTimeout(() => {
			window.print();
		}, 1000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<Helmet>
				<title>{`${firstName} ${lastName} - EQQO Profile Report - ${new Date().toLocaleDateString()}`}</title>
			</Helmet>
			<div className="print-report">
				<div className="cover-page">
					<h1>EQQO Profile</h1>
					<div className="image-container">
						<Image src={EqqoInfinity} />
					</div>
					<h2>You In Relationship</h2>
					<p>{firstName} {lastName}<br />{new Date().toLocaleDateString()}</p>
				</div>
				<div className="report-view">
					<Card body className="bg-white border-0 mb-3">
						<div dangerouslySetInnerHTML={{ __html: introduction?.text }} />
					</Card>
				</div>
				<Emotions showHeader />
				<SelfOther showHeader />
				<EmpathyCompassion showHeader />
				<RelationshipStrategies showHeader />
			</div>
		</>
	);
}

export default PrintReport;
